import RoomCategoryIndexVue from "@/views/room-category/RoomCategoryIndex.vue";

const roomCategory = [
  {
    path: "/room-category",
    name: "room-category",
    component: RoomCategoryIndexVue,
    meta: {
      layout: "default",
      role: ["superadmin","backoffice"],
      public: false,
    },
  },
];

export default roomCategory;
